import { FunctionComponent } from 'react'

import styled from 'styled-components'

import ScoreboardMatchResultSkiOrFormula1 from './ScoreboardMatchResultSkiOrFormula1'
import ScoreboardMatchStatus from './ScoreboardMatchStatus'

const StyledScoreboardMatchResult = styled.div`
  align-items: center;
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
`

const ScoreboardSkiOrFormula1: FunctionComponent = () => {
  return (
    <StyledScoreboardMatchResult>
      <ScoreboardMatchStatus />
      <ScoreboardMatchResultSkiOrFormula1 />
    </StyledScoreboardMatchResult>
  )
}

export default ScoreboardSkiOrFormula1
